<!-- About -->
<div class="About">
    <div class="row">
        <div class="col-md-12 mb-4">
            
            <div class="about-img mx-auto">
                <img src="imgs/logo.png" alt="" class="img-fluid img-contain">
            </div>
            
        </div>
        <div class="col-md-12 mb-4">
            
            <div class="about-info bg-main-color ">
                <p class="text-white border-bottom px-5 py-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dolore facere necessitatibus reiciendis sequi quo, dicta repellendus magnam, cum quisquam quidem repudiandae quod eligendi voluptates laborum ducimus a odio possimus.</p>
                <p class="text-white border-bottom px-5 py-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dolore facere necessitatibus reiciendis sequi quo, dicta repellendus magnam, cum quisquam quidem repudiandae quod eligendi voluptates laborum ducimus a odio possimus.</p>

                <p class="text-white border-bottom px-5 py-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dolore facere necessitatibus reiciendis sequi quo, dicta repellendus magnam, cum quisquam quidem repudiandae quod eligendi voluptates laborum ducimus a odio possimus.</p>

                <p class="text-white border-bottom px-5 py-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam dolore facere necessitatibus reiciendis sequi quo, dicta repellendus magnam, cum quisquam quidem repudiandae quod eligendi voluptates laborum ducimus a odio possimus.</p>

            </div>
            
        </div>
        
    </div>

</div>
<!-- ./About -->